export default {
  title: 'Promocode-details',
  back: 'Terug naar promocodes',
  tabs: {
    customers: 'Klanten',
    orders: 'Bestellingen',
  },
  metrics: {
    gmv: 'GMV',
    average_order_value: 'Gem. bestelwaarde',
    customer_adoption: 'Unieke klanten',
  },
  toasts: {
    failed_to_load_stats: 'Statistieken laden mislukt',
  },
};
